import * as React from "react";

export const ChartHeader: React.FC<{
  id: string;
  loading: string;
  text: string;
  action: () => void;
  showDownloadReport: boolean;
}> = (props) => {
  return (
    <h5>
      {props.text}
      <div onClick={props.action} className="subOption">
        {props.showDownloadReport && props.loading !== props.id && "(download)"}
        {props.loading === props.id && (
          <i className="fa fa-circle-o-notch fa-spin fa-1x fa-fw" />
        )}
      </div>
    </h5>
  );
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Home/components/ChartHeader.tsx